import React from 'react';
import Select from 'react-select';

export default class Filters extends React.Component {
    changeFilter(filterid, option) {
        this.props.navigate({[filterid]: option === null ? '' : option.value});
    }

    render() {
        const {filters, query} = this.props;

        return <form>
            {filters.map((filter, i) => {
                const options = filter.values.map((value) => ({
                    label: value.Title,
                    value: String(value.ID),
                }));

                // An unset filter falls back to its configured default so the
                // select always mirrors what the list actually shows.
                const current = query[filter.id] || filter.default || '';
                const selected = options.find((option) => option.value === String(current)) || null;

                return <div key={i} className="header_filter_field">
                    <Select onChange={(option) => this.changeFilter(filter.id, option)}
                            value={selected}
                            placeholder={filter.title}
                            multi={false}
                            isClearable={true}
                            isSearchable={false}
                            options={options}
                    />
                </div>;
            })}
        </form>;
    }
}
